import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GoogleComponentResources, DefaultGoogleComponentResource } from './google.component.resources';

declare var google: any;

@Component({
  selector: 'app-google',
  standalone: false,
  templateUrl: './google.component.html',
  styleUrls: ['./google.component.scss']
})
export class GoogleComponent implements OnInit {
  // Input and Output For the Component
  @Input() resources: Partial<GoogleComponentResources> = {};
  @Input() clientId!: string;
  @Input() loginHint: string = "";
  @Input() scopes!: string[];
  @Input() showWarningAndErrors: boolean = true; // Controls whether errors are shown
  @Output() successCallBack: EventEmitter<any> = new EventEmitter();
  @Output() failureCallBack: EventEmitter<any> = new EventEmitter();

  private isGoogleInitialized = false;
  finalResources!: GoogleComponentResources;

  private googleClient: any;
  ngOnInit(): void {
    // When Client Id Is Not Present
    if (!this.clientId) {
      throw new Error(this.finalResources.clientIdRequiredErrorMessage);
    }
    // Load the Google script dynamically
    this.loadGoogleScript()
      .then(() => {
        if (!this.isGoogleInitialized) {
          this.initializeGoogleSignIn();
          this.isGoogleInitialized = true;
        }
      })
      .catch((error) => {
        if (this.showWarningAndErrors) {
          console.error(this.finalResources.googleScriptLoadingErrorMessage, error);
        }
      });

    this.finalResources = { ...DefaultGoogleComponentResource, ...this.resources };
  }
  private loadGoogleScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (typeof google !== 'undefined') {
        resolve(); // Google script is already loaded
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.onload = () => resolve(); // Resolve when script is loaded
      script.onerror = () => {
        if (this.showWarningAndErrors) {
          console.error(this.finalResources.googleScriptLoadingErrorMessage);
        }
        reject(this.finalResources.googleScriptLoadingErrorMessage);
      };
      document.head.appendChild(script);
    });
  }

  private initializeGoogleSignIn(): void {
    const scopes = this.scopes.join(' ');
    try {
      // Initialize the Google client to request authorization code
      this.googleClient = google.accounts.oauth2.initCodeClient({
        client_id: this.clientId,
        scope: scopes,
        ux_mode: 'popup',
        login_hint: this.loginHint,
        callback: (response: any) => {
          // Handle When User Denies the Permissions --- Access Denied
          if (response && response.error) {
            this.failureCallBack.emit(response);
          } else {
            this.successCallBack.emit(response);
          }
        },
        error_callback: (err: any) => {
          this.failureCallBack.emit(err);
        }
      });
    } catch (error) {
      if (this.showWarningAndErrors) {
        console.error('Error initializing Google Sign-In:', error);
      }
    }
  }

  googleButtonClicked(): void {
    if (this.googleClient) {
      this.googleClient.requestCode();
    }
  }
}
